import React, { useReducer, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
// import { formatDate } from 'react-day-picker/moment';
// import DayPickerInput from 'react-day-picker/DayPickerInput';
import moment from 'moment';
import styles from './controlPanel.css';
import ExcelBtn from './excelBtn/ExcelBtn';
import EmailBtn from './emailBtn/EmailBtn';
import DeleteStatisticsData from './deleteStatisticsData/DeleteStatisticsData';
import { downloadStatisticsExportFile } from '../../../data/statistics/quiz/actions';
import { isRunningOnClientSide } from '../../../utils/func';
import ReportSetup from './reportSetup/ReportSetup';
import ProtectedComponent from '../../../components/protectedComponent/ProtectedComponent';
const initialState = {
    startDateFormatted: null,
    endDateFormatted: null,
    showReportSetupForm: false,
    activeUrl: isRunningOnClientSide() ? window.location.href.split( '/' ).reverse()[ 0 ] || '' : '',
    deleteStatisticsPopup: false
};

const reducer = ( state = initialState, action ) => {

    switch ( action.type ) {
        case 'ADD-DATA': {
            return { ...state, ...action.data };
        }
        default:
            return state;
    }
};

const initial = state => state;

/**
 *
 * @type {React.NamedExoticComponent<{readonly quizType?: *}>}
 */
const ControlPanel = React.memo( ( { quizType } ) => {
    const { localization: { content }, quizstst: { fileLink = { url: '' } }, quiz: { quiz_localization, quiz_localization: { id } } } = useSelector( state => state );
    const [ data, dispatch ] = useReducer( reducer, initialState, initial );
    const { startDateFormatted, showReportSetupForm, endDateFormatted, activeUrl, deleteStatisticsPopup } = data;
    const [ theFileLink, setFileLink ] = useState();
    const actionDispatch = new useDispatch();

    useEffect( () => {
        dispatch( {
            type: 'ADD-DATA', data: {
                startDateText: content.quiz.players.range_date_text,
                endDateText: content.quiz.players.range_date_text
            }
        } );
    }, [] );

    useEffect( () => {
        dispatch( {
            type: 'ADD-DATA', data: {
                activeUrl: window.location.href.split( '/' ).reverse()[ 0 ] || ''
            }
        } );
    }, [ content ] );


    useEffect( () => {
        if ( !!fileLink.url && fileLink.url !== theFileLink?.url ) {
            setFileLink( fileLink );
            window.location.href = fileLink.url;
        }
    }, [ fileLink ] );



    const exportFile = () => {
        const from = moment( startDateFormatted ).format( 'YYYY-MM-DD' );
        const to = moment( endDateFormatted ).format( 'YYYY-MM-DD' );

        const fromToDates = {};
        if ( from && to ) {
            fromToDates.from = from;
            fromToDates.to = to;
        }

        actionDispatch( downloadStatisticsExportFile( fromToDates, id ) );
    };

    const openPopupDeleteStatisticsData = () => dispatch( {
        type: 'ADD-DATA', data: {
            deleteStatisticsPopup: true
        }
    } );

    const closePopupDeleteStatisticsData = () =>
        dispatch( {
            type: 'ADD-DATA', data: {
                deleteStatisticsPopup: false
            }
        } );

    const activeLinkStyle = { opacity: 1 };

    const showReportSetup = () => {
        dispatch( {
            type: 'ADD-DATA', data: {
                showReportSetupForm: true
            }
                  } );
    };
    const closeReportSetup = () => {
        dispatch( {
            type: 'ADD-DATA', data: {
                showReportSetupForm: false
            }
        } );
    };
    return (
        <nav className={ styles.wrapper }>
            <div className={ styles.panel }>
                <ul className={ styles.menu }>
                    <ProtectedComponent permissions={['quiz_statistics_view']}>
                        <li className={ styles.menuBottom }>
                            <NavLink
                                className={ styles.link }
                                to={ `/${ quizType }/${ quiz_localization.id }/statistics/quiz` }
                                style={ activeUrl === 'quiz' ? activeLinkStyle : {} }
                            >
                                { content.dashboard.quiz }
                            </NavLink>
                        </li>
                    </ProtectedComponent>
                    <li className={ styles.menuBottom }>
                        <NavLink className={ styles.link }
                                 to={ `/${ quizType }/${ quiz_localization.id }/statistics/questions` }
                                 style={ activeUrl === 'questions' ? activeLinkStyle : {} }
                        >
                            { content.quiz.statistics.question }
                        </NavLink>
                    </li>
                    <li className={ styles.menuBottom }>
                        <NavLink className={ styles.link }
                                 to={ `/${ quizType }/${ quiz_localization.id }/statistics/links` }
                                 style={ activeUrl === 'links' ? activeLinkStyle : {} }
                        >
                            { content.quiz.statistics.links_tracking }
                        </NavLink>
                    </li>

                    <ProtectedComponent permissions={['quiz_statistics_export']}>
                    <li>
                        <ExcelBtn onclick={ exportFile } caption={ `${ content.quiz.statistics.export }` }/>
                    </li>
                    </ProtectedComponent>
                    <ProtectedComponent permissions={['quiz_settings']}>
                    <li>
                        <EmailBtn onclick={ showReportSetup } caption={ `${ content.quiz.statistics.mail_report }` }/>
                    </li>
                    </ProtectedComponent>
                </ul>
            </div>
            <ProtectedComponent permissions={['quiz_settings']}>
            <button onClick={ openPopupDeleteStatisticsData } className={ styles.data }>
                { content.quiz.players.delete_all_data }
            </button>
            </ProtectedComponent>
            { deleteStatisticsPopup &&
            <DeleteStatisticsData
                closePopupDeleteStatisticsData={ closePopupDeleteStatisticsData }
                content={ content }
                quizID={ quiz_localization.id }
            />
            }
            { showReportSetupForm && <ReportSetup closeForm = { closeReportSetup } /> }
        </nav>
    );
} );

export default ControlPanel;
